import API_URL from "./apiConfig/api.config";
import apiCall from "./apiConfig/apiCall.config";

export async function getLocation(clubId: string) {
  return await apiCall.get(`${API_URL.ORGANISATION.GET_LOCATION}${clubId}`);
}
